export default function disableCacheReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'DISABLE_CACHE_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'DISABLE_CACHE_ERROR':
            return {...state, ...{error: action.error}};

        case 'DISABLE_CACHE_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}